module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    class: {
      'flexContainer jc-fe': _vm.getMode === 'module'
    },
    attrs: {
      "id": "headerPlano"
    }
  }, [_c('selector-lang', {
    attrs: {
      "classescss": "langselector--in-plano txtCenter uppercase support pointer"
    }
  }), _vm._v(" "), (_vm.getMode !== 'module') ? _c('button', {
    staticClass: "btnLeft uppercase export pointer",
    class: {
      active: _vm.canDisplayExports
    },
    on: {
      "click": _vm.exportPdf
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.export")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode !== 'module' && _vm.lock === 'false' && !_vm.isMobile && !_vm.getPlanoDetails.archived && _vm.getPlanoDetails.status === 'IN PROGRESS') ? _c('button', {
    staticClass: "btnLeft uppercase support pointer",
    class: {
      active: _vm.support
    }
  }, [_c('span', [_c('a', {
    staticClass: "supportLink",
    attrs: {
      "target": "_blank",
      "href": _vm.globals + '/Plano-Builder-Guide-utilisateur.pdf'
    }
  }, [_vm._v(_vm._s(_vm.$t("planobuilder.support")))])])]) : _vm._e(), _vm._v(" "), (
    _vm.getMode !== 'module' &&
    _vm.lock === 'false' &&
    !_vm.isMobile &&
    _vm.hasAccessUpdateAndCreate('plano_builder') &&
    !_vm.getPlanoDetails.archived &&
    _vm.getPlanoDetails.status === 'IN PROGRESS'
  ) ? _c('button', {
    staticClass: "btnLeft uppercase comment pointer",
    class: {
      active: _vm.canDisplayComments
    },
    on: {
      "click": _vm.comments
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.comment")) + " (" + _vm._s(_vm.commentsNB) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.getMode === 'module' && _vm.lock === 'false' && !_vm.isMobile) ? _c('button', {
    staticClass: "btnBase uppercase shades pointer",
    class: {
      active: _vm.canDisplayMenuShades
    },
    on: {
      "click": _vm.shades
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.shades")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode === 'module' && _vm.lock === 'false' && !_vm.isMobile) ? _c('button', {
    staticClass: "btnBase uppercase ticketstrip pointer",
    class: {
      active: _vm.canDisplayMenuTicketStrip
    },
    on: {
      "click": _vm.ticketStrip
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.ticketStrip")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode !== 'module' && _vm.lock === 'false' && !_vm.isMobile && !_vm.getPlanoDetails.archived && _vm.getPlanoDetails.status === 'IN PROGRESS') ? _c('button', {
    staticClass: "btnBase uppercase favorites fright pointer",
    class: {
      active: _vm.canDisplayMenuFavorite
    },
    on: {
      "click": _vm.favorites
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.favorite")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode !== 'module' && _vm.lock === 'false' && !_vm.isMobile && !_vm.getPlanoDetails.archived && _vm.getPlanoDetails.status === 'IN PROGRESS') ? _c('button', {
    staticClass: "btnBase uppercase scratch fright pointer",
    class: {
      active: _vm.canDisplayMenuScratch
    },
    on: {
      "click": _vm.scratchPad
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.scratch")))])]) : _vm._e(), _vm._v(" "), (_vm.getMode !== 'module' && _vm.lock === 'false' && !_vm.isMobile && !_vm.getPlanoDetails.archived && _vm.getPlanoDetails.status === 'IN PROGRESS') ? _c('button', {
    staticClass: "btnBase uppercase library fright pointer",
    class: {
      active: _vm.canDisplayMenuLibrary
    },
    on: {
      "click": _vm.library
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.library")))])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78436d31","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/MenuMainPlano.vue
// module id = 3279
// module chunks = 0